export default __webpack_public_path__ + "static/media/sb-ICO-09.079ff893.webp";